/* eslint-disable jira/filename-case */
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';

export const PAGE_LAYOUT_OFFSET_TOP_UNGROUPED: 'var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)' = `${UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
export const PAGE_LAYOUT_OFFSET_TOP: '(var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px))' = `(${PAGE_LAYOUT_OFFSET_TOP_UNGROUPED})`;
